import { takeLatest } from 'redux-saga/effects';
import getReturnUrl from 'src/app/api/getReturnUrl';

import { SHOULD_REDIRECT } from 'src/app/redux/actions/isLoggedIn';


function* shouldRedirect({ logged }) {
  if (logged) {
    yield window.location.assign(getReturnUrl());
  }
}

export default [
  takeLatest(SHOULD_REDIRECT, shouldRedirect)
];
